import { useRef } from 'react';
import { usePaymentPixInstructionsModal } from '../screens/payment/payment-pix-instructions-modal';
import { usePaymentPixQRCodeModal } from '../screens/payment/payment-pix-qrcode-modal';
import { useStorage } from '../hooks/use-storage';
import { usePaymentPixManager } from '../utils/manager/payment-pix-manager';

function usePaymentPixWorkflow() {
  const { preparePaymentPixQRCodeModal, showPaymentPixQRCodeModal } =
    usePaymentPixQRCodeModal();
  const {
    preparePaymentPixInstructionsModal,
    showPaymentPixInstructionsModal,
  } = usePaymentPixInstructionsModal();
  const { refreshPaymentPix } = usePaymentPixManager();
  const { paymentRef } = useStorage();

  const ordersRef = useRef();
  const tipAmountRef = useRef();

  async function prepare({ orders, tipAmount }) {
    ordersRef.current = orders;
    tipAmountRef.current = tipAmount;

    if (paymentRef.current != null && paymentRef.current.status === 'paying') {
      await refreshPaymentPix({ payment: paymentRef.current, orders });
    }

    await preparePaymentPixQRCodeModal({ orders, tipAmount });
  }

  async function show({ prepareOnPreConfirm, prepareOnPreDeny } = {}) {
    let repeat = false;

    /* eslint-disable no-await-in-loop */
    let result;

    do {
      result = await showPaymentPixQRCodeModal({
        prepareOnPreDeny,
        prepareOnPreConfirm: async () => {
          await preparePaymentPixInstructionsModal({
            orders: ordersRef.current,
            tipAmount: tipAmountRef.current,
          });
        },
      });

      if (result.isConfirmed) {
        result = await showPaymentPixInstructionsModal({
          copied: result.copied,
          prepareOnPreConfirm,
          prepareOnPreDeny: async () => {
            await preparePaymentPixQRCodeModal({
              orders: ordersRef.current,
              tipAmount: tipAmountRef.current,
            });
          },
        });
        // TODO: teste
      }

      repeat = result.wasBackButtonClicked;
    } while (repeat);

    return result;
  }

  return {
    preparePaymentPixWorkflow: prepare,
    showPaymentPixWorkflow: show,
  };
}

export { usePaymentPixWorkflow };
